import { render, staticRenderFns } from "./collected.vue?vue&type=template&id=ddb48024&scoped=true&"
import script from "./collected.vue?vue&type=script&lang=js&"
export * from "./collected.vue?vue&type=script&lang=js&"
import style0 from "./collected.vue?vue&type=style&index=0&id=ddb48024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb48024",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default,News: require('/var/jenkins_home/workspace/prod-web-xfans/components/news.vue').default,Discussion: require('/var/jenkins_home/workspace/prod-web-xfans/components/discussion.vue').default,Course: require('/var/jenkins_home/workspace/prod-web-xfans/components/course.vue').default,Activity: require('/var/jenkins_home/workspace/prod-web-xfans/components/activity.vue').default})
